// Datos geográficos compartidos por el registro, "Mi Empresa" y las vitrinas.
// - AMERICAN_COUNTRIES: lista de países para el selector de país.
// - COLOMBIA_CITIES: departamentos de Colombia con sus ciudades/municipios
//   principales. Cuando el país es Colombia, departamento y ciudad se eligen de
//   estos dropdowns; para el resto de países se escriben como texto libre. En la
//   UI siempre se ofrece además una opción "Otra" por si el municipio no está.

export const AMERICAN_COUNTRIES = [
  'Argentina', 'Bahamas', 'Barbados', 'Belice', 'Bolivia', 'Brasil',
  'Canadá', 'Chile', 'Colombia', 'Costa Rica', 'Cuba', 'Ecuador',
  'El Salvador', 'Estados Unidos', 'Guatemala', 'Guyana', 'Haití',
  'Honduras', 'Jamaica', 'México', 'Nicaragua', 'Panamá', 'Paraguay',
  'Perú', 'Puerto Rico', 'República Dominicana', 'Surinam',
  'Trinidad y Tobago', 'Uruguay', 'Venezuela',
];

// Departamentos de Colombia -> ciudades/municipios principales.
export const COLOMBIA_CITIES = {
  'Amazonas': ['Leticia', 'Puerto Nariño'],
  'Antioquia': ['Medellín', 'Bello', 'Itagüí', 'Envigado', 'Rionegro', 'Apartadó', 'Turbo', 'Sabaneta', 'La Estrella', 'Copacabana', 'Caldas', 'Marinilla'],
  'Arauca': ['Arauca', 'Saravena', 'Tame', 'Arauquita', 'Fortul'],
  'Atlántico': ['Barranquilla', 'Soledad', 'Malambo', 'Sabanalarga', 'Puerto Colombia', 'Galapa', 'Baranoa'],
  'Bogotá D.C.': ['Bogotá D.C.'],
  'Bolívar': ['Cartagena', 'Magangué', 'Turbaco', 'Arjona', 'El Carmen de Bolívar'],
  'Boyacá': ['Tunja', 'Duitama', 'Sogamoso', 'Chiquinquirá', 'Paipa', 'Villa de Leyva'],
  'Caldas': ['Manizales', 'La Dorada', 'Chinchiná', 'Villamaría', 'Riosucio', 'Anserma'],
  'Caquetá': ['Florencia', 'San Vicente del Caguán', 'Puerto Rico', 'El Doncello'],
  'Casanare': ['Yopal', 'Aguazul', 'Villanueva', 'Tauramena', 'Paz de Ariporo'],
  'Cauca': ['Popayán', 'Santander de Quilichao', 'Puerto Tejada', 'Patía (El Bordo)'],
  'Cesar': ['Valledupar', 'Aguachica', 'Agustín Codazzi', 'La Jagua de Ibirico', 'Bosconia'],
  'Chocó': ['Quibdó', 'Istmina', 'Condoto', 'Tadó', 'Bahía Solano'],
  'Córdoba': ['Montería', 'Cereté', 'Lorica', 'Sahagún', 'Montelíbano', 'Planeta Rica', 'Tierralta'],
  'Cundinamarca': ['Soacha', 'Fusagasugá', 'Girardot', 'Zipaquirá', 'Facatativá', 'Chía', 'Mosquera', 'Madrid', 'Funza', 'Cajicá', 'Cota', 'Villeta'],
  'Guainía': ['Inírida'],
  'Guaviare': ['San José del Guaviare', 'Calamar', 'El Retorno'],
  'Huila': ['Neiva', 'Pitalito', 'Garzón', 'La Plata', 'Campoalegre'],
  'La Guajira': ['Riohacha', 'Maicao', 'Uribia', 'Fonseca', 'San Juan del Cesar'],
  'Magdalena': ['Santa Marta', 'Ciénaga', 'Fundación', 'El Banco', 'Zona Bananera'],
  'Meta': ['Villavicencio', 'Acacías', 'Granada', 'Puerto López', 'Cumaral'],
  'Nariño': ['Pasto', 'Tumaco', 'Ipiales', 'Túquerres', 'La Unión'],
  'Norte de Santander': ['Cúcuta', 'Ocaña', 'Pamplona', 'Villa del Rosario', 'Los Patios'],
  'Putumayo': ['Mocoa', 'Puerto Asís', 'Orito', 'Valle del Guamuez (La Hormiga)'],
  'Quindío': ['Armenia', 'Calarcá', 'La Tebaida', 'Montenegro', 'Quimbaya'],
  'Risaralda': ['Pereira', 'Dosquebradas', 'Santa Rosa de Cabal', 'La Virginia'],
  'San Andrés y Providencia': ['San Andrés', 'Providencia'],
  'Santander': ['Bucaramanga', 'Floridablanca', 'Girón', 'Piedecuesta', 'Barrancabermeja', 'San Gil', 'Barbosa'],
  'Sucre': ['Sincelejo', 'Corozal', 'Sampués', 'San Marcos', 'Santiago de Tolú'],
  'Tolima': ['Ibagué', 'Espinal', 'Melgar', 'Honda', 'Líbano', 'Chaparral'],
  'Valle del Cauca': ['Cali', 'Buenaventura', 'Palmira', 'Tuluá', 'Cartago', 'Buga', 'Jamundí', 'Yumbo', 'Candelaria'],
  'Vaupés': ['Mitú'],
  'Vichada': ['Puerto Carreño', 'La Primavera', 'Cumaribo'],
};

export const COLOMBIA_DEPARTMENTS = Object.keys(COLOMBIA_CITIES);

export const isColombia = (pais) => (pais || '').trim().toLowerCase() === 'colombia';
